// External modules
import React from 'react';
import { useStoreState } from '@/store';
// @ts-expect-error untyped-import
import { LoadingSpinner } from '@checkout/react-components';

// Internal modules
import { features } from '@/lib/features';
import { EmotionWrapper } from '../../Layout/Components';
import { TransitionSpinnerContainer } from './TransitionSpinnerContainer';
import { SPINNER_TYPES } from '@/store/models/constants';

type SpinnerRenderProps = {
  containToParent?: boolean;
  overlayStyleOverrides?: React.CSSProperties;
};
export const SpinnerRender = ({
  containToParent = false,
  overlayStyleOverrides,
}: SpinnerRenderProps): JSX.Element => {
  const useProgressiveSpinner = !features.isActive('isWps');
  const spinnerType = useStoreState(({ ui }) => ui.spinnerType);
  let spinnerContent;

  if (useProgressiveSpinner) {
    switch (spinnerType) {
      case SPINNER_TYPES.almostDone:
        spinnerContent = (
          <TransitionSpinnerContainer
            titleContent="spinner.almostDone"
            subTitleContent="spinner.nowFinishPayingAt"
            icon="purchase"
          />
        );
        break;
      case SPINNER_TYPES.takingYouBack:
        spinnerContent = (
          <TransitionSpinnerContainer subTitleContent="spinner.takingYouBackToMerchant" />
        );
        break;
      case SPINNER_TYPES.thankYou:
        spinnerContent = (
          <TransitionSpinnerContainer
            titleContent="spinner.thanksForUsingPaypal"
            icon="purchase"
          />
        );
        break;
      default:
        spinnerContent = <TransitionSpinnerContainer />;
    }
  } else {
    spinnerContent = (
      <LoadingSpinner
        containToParent={containToParent}
        overlayStyleOverrides={overlayStyleOverrides}
        testId="loading-spinner"
      />
    );
  }
  return <EmotionWrapper>{spinnerContent}</EmotionWrapper>;
};
